import { StyleSheet } from '@react-pdf/renderer'

export const styles = StyleSheet.create({
  box: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    gap: 8,
    padding: '24px',
  },
  canvas: {
    backgroundColor: '#E9ECEF',
    borderRadius: 8,
    height: 12,
    marginBottom: 10,
  },
  chartInfo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  charts: {
    gap: 16,
  },
  text: {
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: 'normal',
  },
  title: {
    fontFamily: 'Montserrat',
    fontSize: 18,
    fontWeight: 'semibold',
    marginBottom: '18px',
  },
})
